export const AppLanguage = {
  PL: 'pl',
  EN: 'en',
} as const;

export type Language = (typeof AppLanguage)[keyof typeof AppLanguage];
